import React, { useEffect, useState } from "react";
import styled from "styled-components";

const Button = styled.div`
    width: 100%;
    height: 56px;
    max-width: 327px;
    align-self: center;
    border-radius: 30px;
    cursor: pointer;
    font-size: 16px;
    font-weight: 700;
    line-height: 24px;
    text-align: center;
    transition: all 0.1s ease;

    &.primary {
        &.normal {
            background-color: #FBE250;
            color: #25368D;
        }

        &.normal-lg {
            background-color: #FBE250;
            color: #25368D;

            &:hover {
                background-color: #FBE25099;
            }
        }


        &.disable {
            cursor: default;
            background-color: #FFF4B4;
            color: #838BB4;
        }
    }

    &.secondary {
        width: calc(100% - 6px);
        height: 50px;

        &.normal {
            background-color: #FFFFFF;
            border: 3px solid #FBE250;
            color: #25368D;
        }

        &.normal-lg {
            background-color: #FFFFFF;
            border: 3px solid #FBE250;
            color: #25368D;

            &:hover {
                background-color: #FBE25099;
            }
        }

        &.disable {
            cursor: default;
            background-color: #B3B3B333;
            color: #838BB4;
        }
    }

    &.delete {
        &.normal {
            background-color: #D36060;
            color: #FFFFFF;
        }

        &.normal-lg {
            background-color: #D36060;
            color: #FFFFFF;

            &:hover {
                background-color: #D3606099;
            }
        }


        &.disable {
            cursor: default;
            background-color: #D3606099;
            color: #FFFFFF;
        }
    }

    .icon {
        &.start {
            margin-right: 16px;
        }

        &.end {
            margin-left: 16px;
        }
    }

`;


function ButtonComponent({
    label,
    disable,
    variant,
    icon,
    iconPosion,
    className,
    style,
    sceenSize,
    onClick,
}) {
    function handleClick() {
        if (disable) return
        onClick && onClick();
    }

    return (
        <Button
            className={`${className} content-center ${variant || "primary"} ${disable ? "disable" : `normal${sceenSize === "lg" ? "-lg" : ""}`}`}
            style={{ ...style }}
            onClick={handleClick}>
            {(icon && iconPosion !== "end") && <img className="icon start" alt="img" src={icon} />}
            {label || "Button"}
            {(icon && iconPosion === "end") && <img className="icon end" alt="img" src={icon} />}
        </Button>
    )
}

export default ButtonComponent